import { useState, useEffect } from "react";
import { styled, XStack, YStack, Text } from "tamagui";
import { jsx, jsxs } from "react/jsx-runtime";
const SafeNumericLabel = ({
  sharedValue,
  prefix = "",
  suffix = ""
}) => {
  const [displayValue, setDisplayValue] = useState(sharedValue.value);
  useEffect(() => {
    const val = sharedValue.value;
    const formatted = val === void 0 || val === null || isNaN(val) ? "" : `${prefix}${typeof val === "number" ? val.toFixed(0) : val}${suffix}`;
    setDisplayValue(formatted);
  }, [sharedValue.value, prefix, suffix]);
  return /* @__PURE__ */jsx(Text, {
    fontSize: 10,
    fontWeight: "bold",
    color: "$color",
    children: displayValue
  });
};
const LegendItem = styled(XStack, {
  marginHorizontal: 5,
  alignItems: "center",
  gap: 5
});
const ColorBox = styled(YStack, {
  width: 10,
  height: 10,
  borderRadius: 100
});
const Legend = ({
  legendData
}) => /* @__PURE__ */jsx(XStack, {
  flexWrap: "wrap",
  marginVertical: 10,
  children: legendData?.map(item => /* @__PURE__ */jsxs(LegendItem, {
    children: [/* @__PURE__ */jsx(ColorBox, {
      backgroundColor: item.fill
    }), /* @__PURE__ */jsx(Text, {
      fontSize: 12,
      children: item.name
    })]
  }, item.name))
});
export { ColorBox, Legend, LegendItem, SafeNumericLabel };
//# sourceMappingURL=charts-common.mjs.map
